import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { TSP } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  public user$: BehaviorSubject<TSP.Internal.Recruiter.User.Details | null> =
    new BehaviorSubject<TSP.Internal.Recruiter.User.Details | null>(null);

  private readonly http = inject(HttpClient);

  public getCurrentUser(): Observable<TSP.Internal.Recruiter.User.Details> {
    return this.http.get<TSP.Internal.Recruiter.User.Details>('/user').pipe(tap((user) => this.user$.next(user)));
  }
}
